var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNormalFolder = function SvgNormalFolder(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2744 12.8514L18.2888 8H5.82483C4.44756 8 3.33203 9.08549 3.33203 10.4257V51.6623C3.33203 54.3415 5.56433 56.5137 8.31763 56.5137H55.6808C58.4341 56.5137 60.6664 54.3415 60.6664 51.6623V17.7027C60.6664 15.0236 58.4341 12.8514 55.6808 12.8514H23.2744Z",
    fill: "url(#paint0_linear_5323_308908)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6664 19.7609H3.33203V10.3522C3.33203 9.0526 4.44756 8 5.82483 8H18.2888L23.2744 12.7044H55.6808C58.4341 12.7044 60.6664 14.8107 60.6664 17.4087V19.7609Z",
    fill: "url(#paint1_linear_5323_308908)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1968 19.7622H4.80261C4.80261 16.0293 4.80508 13.6294 4.80396 10.0239C4.80387 9.71936 5.05072 9.47144 5.35528 9.47144H18.0336L23.179 14.2493L57.8157 14.1786C58.578 14.1771 59.1968 14.7946 59.1968 15.5569C59.1968 17.5306 59.1968 19.4648 59.1968 19.7622Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6664 19.761H3.33203V15.4977C3.33203 14.1981 4.44756 13.1455 5.82483 13.1455H18.2888L23.2744 17.8499H60.6664C60.6664 19.026 60.6664 19.026 60.6664 19.761Z",
    fill: "#63B4F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6664 19.761H3.33203V15.4977C3.33203 14.1981 4.44756 13.1455 5.82483 13.1455H18.2888L23.2744 17.8499H60.6664C60.6664 19.026 60.6664 19.026 60.6664 19.761Z",
    fill: "url(#paint2_linear_5323_308908)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5323_308908",
    x1: 4.00093,
    y1: 11.687,
    x2: 61.5154,
    y2: 14.7586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1088E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1966AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5323_308908",
    x1: 4.00093,
    y1: 8.89383,
    x2: 59.0099,
    y2: 21.0119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B59A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5323_308908",
    x1: 4.00093,
    y1: 13.6483,
    x2: 54.0094,
    y2: 33.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B59A2"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNormalFolder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "normalFolder.9ae6e6f71f4b1f2e08f3ae1860e379f7.svg";